<template>
  <div class="home">
    <MessageTemplateList  @clicked="onClickChild" @newMessage="onClickChildNew" @editMessage="onClickChild" v-show="listView" :scroll="corY" ref="refreshList" />
    <MessageTemplateForm :template="template" v-show="formView" @backClicked="onBackChild" />
  </div>
</template>

<script>
// @ is an alias to /src
import MessageTemplateList from '@/components/message/MessageTemplateList.vue'
import MessageTemplateForm from '@/components/message/MessageTemplateForm.vue'

export default {
  name: 'MessageTemplate',
  components: {
    MessageTemplateList,
    MessageTemplateForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      template: {
        template_id: null,
        message: null,
        url: null
      }
    }
  },
  methods: {
    onClickChild: function (value) {
      this.template = value
      this.listView = false
      this.formView = true
    },
    onClickChildNew: function () {
      this.template = {
        template_id: null,
        message: null,
        url: null
      }
      this.listView = false
      this.formView = true
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  }
}
</script>
